// API
import { fetchReports, updateRegistrant, downloadReport } from "@/api/events";

// Deserializer
import { deserializeReport } from "@/utils/deserializers/reportsDeserializer";

// Actions
import { showToasterMessage } from "./commonActions";

// Constants
import { toasterMessage } from "@/utils/toaster-msg";
import { ACCESS_TYPE } from "./universityDetailsActions";
export const SET_REPORTS = "SET_REPORTS";
export const LOADING_REPORTS = "LOADING_REPORTS";
export const DOWNLOADING_REPORTS = "DOWNLOADING_REPORTS";

export const USER_TYPE = {
    student: "Student",
    internalTeam: "Internal team",
    universityRepresentative: "University representative",
    attendedOnlineForOffline: "Attended Online for an offline event",
};

export const setReports = (payload) => {
    return { type: SET_REPORTS, payload };
};

export const loadingReports = (payload) => {
    return { type: LOADING_REPORTS, payload };
};

export const downloadingReports = (payload) => {
    return { type: DOWNLOADING_REPORTS, payload };
};

export const reportsGetAndStore = (query, successCb) => {
    return (dispatch) => {
        dispatch(loadingReports(true));
        fetchReports(query)
            .then((res) => {
                dispatch(
                    setReports({
                        data: res.data.map((item) => deserializeReport(item, query.access)),
                        total: Number(res.headers.total_count),
                        totalStudents:
                            query.access === ACCESS_TYPE.university
                                ? Number(res.headers.total_count)
                                : Number(res.headers.total_students_count),
                    })
                );
                successCb && successCb();
            })
            .catch(() => {
                dispatch(
                    setReports({
                        data: [],
                        total: 0,
                        totalStudents: 0,
                    })
                );
            });
    };
};

export const updateUserInReportAndStore = (payload, cb) => {
    return (dispatch, getState) => {
        updateRegistrant(payload)
            .then(() => {
                const reportState = getState().reports;
                const reports = [...reportState.data];
                const reportIndex = reports.findIndex((item) => item.registrantCode === payload.unique_code);

                const userType = payload.user_type;
                const existingType = reports[reportIndex].type;
                let totalStudents = reportState.totalStudents;

                reports[reportIndex] = { ...reports[reportIndex], type: userType };
                if (
                    (!existingType ||
                        existingType === "-" ||
                        existingType === USER_TYPE.student ||
                        existingType === USER_TYPE.attendedOnlineForOffline) &&
                    (userType === USER_TYPE.internalTeam || userType === USER_TYPE.universityRepresentative)
                ) {
                    totalStudents = Math.max(reportState.totalStudents - 1, 0);
                } else if (
                    (existingType === USER_TYPE.internalTeam ||
                        existingType === USER_TYPE.universityRepresentative) &&
                    (userType === USER_TYPE.student || userType === USER_TYPE.attendedOnlineForOffline)
                ) {
                    totalStudents = reportState.totalStudents + 1;
                }

                dispatch(
                    setReports({
                        data: reports,
                        total: reportState.total,
                        totalStudents: totalStudents,
                    })
                );
                dispatch(
                    showToasterMessage(toasterMessage.reportUpdated.msg, toasterMessage.reportUpdated.color)
                );
            })
            .catch(() => {
                dispatch(
                    showToasterMessage(
                        toasterMessage.reportUpdateFail.msg,
                        toasterMessage.reportUpdateFail.color
                    )
                );
            })
            .finally(() => {
                cb && cb();
            });
    };
};

export function downloadReports(query, filename) {
    return (dispatch) => {
        dispatch(downloadingReports(true));
        downloadReport(query)
            .then((res) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([res.data])),
                    link = document.createElement("a"),
                    match = (res.headers["content-disposition"] || "").match(/filename=(.*?)\.(.*)/);

                let ext = "xlsx";
                if (match) {
                    filename = filename || match[1].trim();
                    ext = match[2];
                }

                if (filename) link.download = `${filename}.${ext}`;
                link.href = downloadUrl;
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
            .catch(() => {
                dispatch(
                    showToasterMessage(
                        toasterMessage.reportDownloadFail.msg,
                        toasterMessage.reportDownloadFail.color
                    )
                );
            })
            .finally(() => dispatch(downloadingReports(false)));
    };
}
